<div class="container-fluid d-flex flex-fill flex-column gap-7">
    <div class="row">
        <div class="col-12 d-flex justify-content-between align-items-center px-0">
            <span class="heading-4 fw-semi-bold">Instagram</span>
        </div>
    </div>
    <div class="row">
        <div class="col-12 px-0">
            <span class="fs-7">Customise how your post will appear on Instagram.</span>
        </div>
    </div>
    <div class="row">
        <div class="col-12 col-md-7 d-flex flex-column gap-7 ps-0">
            <div class="d-flex flex-column gap-6">
                <div class="d-flex flex-column gap-2">
                    <pp-text-area id="instaPostTitle"
                        [form]="form"
                        placeholder="Title (optional)"
                        [rows]="2" />
                    <span class="fs-8 text-muted">Optional — Instagram has no separate title field. Leave this blank to post with just your caption below.</span>
                </div>
                <pp-text-area id="instaPostDescription"
                    [form]="form"
                    placeholder="Caption (required)"
                    [rows]="6" />
                <pp-checkbox [checked]="$safeNavigationMigration(form.get('instaIncludeOddrLink')?.value)"
                    id="instaIncludeOddrLink"
                    label="Include the ODDR verified link in the post description"
                    (checkChanged)="oddrLinkSelected($event)" />
            </div>
        </div>
        <div class="col-12 col-md-5 mt-8 mt-md-0 d-flex justify-content-center justify-content-md-start">
            <pp-post-preview provider="instagram"
                [title]="$safeNavigationMigration(form.get('instaPostTitle')?.value)"
                [caption]="$safeNavigationMigration(form.get('instaPostDescription')?.value)"
                [includeOddrLink]="$safeNavigationMigration(form.get('instaIncludeOddrLink')?.value)"
                [oddrLink]="previewOddrLink"
                [thumbnailUrl]="previewThumbnailUrl"
                [mediaType]="previewMediaType"
                [imageCount]="previewImageCount" />
        </div>
    </div>
</div>
<div class="d-flex justify-content-between align-items-center mt-10">
    <ng-container *ngTemplateOutlet="uploadStatusIndicator" />
    <pp-button [disabled]="form.invalid"
        [shape]="buttonShape.Square"
        [variant]="buttonVariant.Primary"
        (buttonClick)="submitAndGoToNextStep()">Next</pp-button>
</div>

<ng-template #uploadStatusIndicator>
    @if (uploadProgress > 0 && !uploadComplete()) {
        <div class="upload-progress-inline d-flex align-items-center gap-6">
            <span class="fs-6 fw-semi-bold text-nowrap">Uploading... {{ uploadProgress }}%</span>
            <div class="upload-progress-bar-track">
                <div class="upload-progress-bar-fill" [style.width.%]="uploadProgress"></div>
            </div>
        </div>
    } @else if (uploadComplete() && !processingComplete()) {
        <div class="d-flex align-items-center gap-3">
            <span class="fs-6 fw-semi-bold text-nowrap">Processing...</span>
        </div>
    } @else if (processingComplete()) {
        <div class="d-flex align-items-center gap-3">
            <img alt="Ready" src="/assets/images/icons/check-circle-solid-primary.svg" height="24px" width="24px" />
            <span class="fs-6 fw-semi-bold text-nowrap">Ready</span>
        </div>
    } @else {
        <div></div>
    }
</ng-template>
